import React from 'react';
import {
  MobileCardsWrapper,
  MobileCardContainer,
  MobileCardLine,
  TextOpacity,
} from './styles';
import { IInstallment } from 'v3/services/interfaces/response';
import { amountFormatter } from 'utils/formatters';
import { formatDateSimple } from 'utils/formatDate';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { BodySmallBoldStyled } from 'v3/shared/typography/BodySmall/styles';

const InstallmentMobileRow: React.FC<{ data: IInstallment; count: number }> = ({ data, count }) => {
  return (
    <MobileCardContainer>
      <MobileCardLine>
        <BodySmallBoldStyled>Parcela {`${String(data.number).padStart(2, '0')} de ${String(count).padStart(2, '0')}`}</BodySmallBoldStyled>
      </MobileCardLine>

      <MobileCardLine>
        <TextOpacity>
          <BodySmallRegular>Data de vencimento</BodySmallRegular>
        </TextOpacity>
        <BodySmallRegular>{formatDateSimple(data.dueDate)}</BodySmallRegular>
      </MobileCardLine>

      <MobileCardLine>
        <TextOpacity>
          <BodySmallRegular>Data de pagamento</BodySmallRegular>
        </TextOpacity>
        <BodySmallRegular>{data.paymentDate ? formatDateSimple(data.paymentDate) : '-'}</BodySmallRegular>
      </MobileCardLine>

      <MobileCardLine>
        <TextOpacity>
          <BodySmallRegular>Valor da parcela</BodySmallRegular>
        </TextOpacity>
        <BodySmallRegular>{amountFormatter(data.amount)}</BodySmallRegular>
      </MobileCardLine>

      <MobileCardLine>
        <TextOpacity>
          <BodySmallRegular>Valor pago</BodySmallRegular>
        </TextOpacity>
        <BodySmallRegular>{amountFormatter(data.presentAmount)}</BodySmallRegular>
      </MobileCardLine>
    </MobileCardContainer>
  );
};

interface PaidInstallmentsMobileTableProps {
  data: IInstallment[];
  count: number;
}

export const PaidInstallmentsMobileTable: React.FC<PaidInstallmentsMobileTableProps> = ({ data, count }) => {
  return (
    <MobileCardsWrapper>
      {data.map((row) => (
        <InstallmentMobileRow key={row.number} data={row} count={count} />
      ))}
    </MobileCardsWrapper>
  );
};